import React from 'react'

import '../Panels.scss'

export const InfoPanel = () => {
  return (
    <section className="panel">
      <h2 className="panel-headline">
        Welcome to the Conker&apos;s Bad Fur Day decompilation website!
      </h2>
      <div className="panel-text">
      </div>
    </section>
  )
}
